import type { DownloadFn, RequestDownloadFn } from "./download/DownloadContext.tsx"

import type { Lang } from "@iyk/vf-app-config"
import { AudioPlayer } from "./audio-player/AudioPlayer.ts"
import { AudioPlayerProvider } from "./audio-player/AudioPlayerProvider.tsx"
import { useAudioPlayer } from "./audio-player/useAudioPlayer.ts"
import { AudioPlayerBottomBar } from "./AudioPlayerBottomBar.tsx"
import { AudioPlayerDrawer, Utils } from "./AudioPlayerDrawer.tsx"
import { DownloadProvider } from "./download/DownloadProvider.tsx"
import { PlaylistInteractionProvider } from "./playlist-interaction/PlaylistInteractionProvider.tsx"
import { usePlaylistInteraction } from "./playlist-interaction/usePlaylistInteraction.tsx"
import { PlayPauseButton } from "./PlayPauseButton.tsx"
import { ReleaseDateTag } from "./ReleaseDateTag.tsx"

const PlaylistProvider = ({
  children,
  onTrackPlay,
  onTrackEnd,
  onTrackSkip,
  download,
  requestDownload,
  user,
  bottomBarClassName,
  lang
}: PlaylistProvider.Props) => {
  return (
    <AudioPlayerProvider
      onTrackPlay={onTrackPlay}
      onTrackEnd={onTrackEnd}
      onTrackSkip={onTrackSkip}
      lang={lang}
    >
      <DownloadProvider download={download} requestDownload={requestDownload} user={user}>
        <PlaylistInteractionProvider>
          {children}
          <AudioPlayerBottomBar className={bottomBarClassName} />
        </PlaylistInteractionProvider>
      </DownloadProvider>
    </AudioPlayerProvider>
  )
}

namespace PlaylistProvider {
  export type Props = {
    children: React.ReactNode
    bottomBarClassName?: string
    lang?: Lang
  } & AudioPlayerProvider.Props &
    DownloadProvider.Props
}

export const Playlist = {
  AudioPlayerDrawer,
  PlayPauseButton,
  Provider: PlaylistProvider,
  ReleaseDateTag,
  useAudioPlayer,
  usePlaylistInteraction,
  Utils
}

export { AudioPlayer }

export type { DownloadFn, RequestDownloadFn }
